import React from "react";

import { useTranslation } from "react-i18next";

import {
    Button,
    Dialog,
} from "fe-shared/src/components";

interface Props {
    isActive: boolean;
    onClose: () => void;
}

const OverrideRegYearWarningDialog = ({
    isActive,
    onClose,
}: Props) => {
    const { t } = useTranslation();

    const actions: React.ReactNode[] = [
        <Button
            key="2"
            id="override-reg-year-cancel"
            variant="outlined"
            onClick={onClose}
        >
            {t("transactions.details.regYear.okGotIt")}
        </Button>,
    ];

    return (
        <Dialog
            modal
            isActive={isActive}
            onClose={onClose}
            title={t("transactions.details.regYear.dialogTitle")}
            actions={actions}
        >
            <span>{t("transactions.details.regYear.warningDialogMessage")}</span>
        </Dialog>
    );
}

export default OverrideRegYearWarningDialog;